export default {
  TOGGLE_SIDEBAR (state, payload) {
    state.sidebar = payload
  }
}
